var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slide-verify',{attrs:{"l":42,"r":10,"w":310,"h":155,"slider-text":this.$t('captcha.slide_right')},on:{"success":_vm.onSuccess,"fail":_vm.onFail,"refresh":_vm.onRefresh}})}
var staticRenderFns = []

export { render, staticRenderFns }